"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModeSignalLogicalStateConditionSchema = void 0;
exports.isModeSignalLogicalStateCondition = isModeSignalLogicalStateCondition;
const zod_1 = require("zod");
const SignalId_1 = require("./SignalId");
exports.ModeSignalLogicalStateConditionSchema = zod_1.z.object({
    signalId: SignalId_1.SignalIdSchema,
});
function isModeSignalLogicalStateCondition(condition) {
    return condition.signalId !== undefined;
}
//# sourceMappingURL=ModeSignalLogicalStateCondition.js.map